export function updateOrder(arr: any[], beg: number, end: number) {
    const copy = arr.slice(0);
    const val = copy[beg];
    copy.splice(beg, 1);
    copy.splice(end, 0, val);
    return copy;
}

export function clamp(n: number, min: number, max: number) {
    return Math.max(Math.min(n, max), min);
}


// WEBPACK FOOTER //
// ./src/Utils/OrderUtils.tsx